import AbstractProductType from './AbstractProductType'
import { ProductTypeFormat } from './types'

export default class SelfCovered extends AbstractProductType {

  name = 'self_covered'
  title = 'Self Covered'

  format = ProductTypeFormat.Covered

}
